import StepIndicator from '../StepIndicator'
import PaymentMethods from '../PaymentMethods/PaymentMethods.vue'
import TransactionSummary from '../TransactionSummary/TransactionSummary.vue'
import Login from '../Login/Login.vue'
import Signup from '../Signup/Signup.vue'
import Redirect from '../Redirect/Redirect.vue'
import { getItems, totalAmount } from '../../services/shopping-cart'

export default {
  data() {
    return {
      products: [],
      cartItems: [],
      currency: 'HTG',
      totalAmount: 0,
      steps: 4,
      activeStep: 1,
      showSignupForm: false,
      redirectUrl: '',
      stepLabels: [
        'Summary',
        'Login',
        'Payment',
        'Done'
      ],
      showLabel: true
    }
  },
  components: {
    StepIndicator,
    TransactionSummary,
    Login,
    Signup,
    PaymentMethods,
    Redirect
  },
  mounted() {
    this.$scrollTo('#top', 1000)
  },
  beforeMount() {
    // let order = JSON.parse(localStorage.getItem('order'))
    this.products = getItems()
    this.totalAmount = totalAmount()
    this.cartItems = getItems().length
    // let prevRoute = localStorage.getItem('previousRoute')
    // WORKAROUND: Resolve token from localStorage to
    // fix `loggedIn` variable always equals `false` bug
    // let authToken = localStorage.getItem('authToken')
    // if (prevRoute === '/checkout' && authToken) {
    //   this.activeStep = 3
    // }
  },
  methods: {
  },
  props: [
    'loggedIn'
  ]
}



// WEBPACK FOOTER //
// ./src/components/Checkout/Checkout.js